import { FormSection, RenderEditOptions } from "components/MainSectionTemplate/types";
import Tag from "components/Tag/Tag";
import React from "react";
import { formatCurrency, formatWrittenDayMonthYear } from "utilities";
import ClientSubscriptionSummaryContent from "../../Subscription/ClientSubscriptionSummaryContent";
import moment from "moment";
import { OptionalDatePicker } from "components/DatePicker/OptionalDatePicker";

interface Props {
  customerSince: moment.Moment,
  customerChurn: moment.Moment,
  client: server.dto.Client,
  activeSubscription: server.dto.Subscription,
  nextSubscription: server.dto.NextSubscription
  discount: server.dto.ClientDiscount
  billingDetails: server.dto.ClientBillingDetails
  subscriptions: server.dto.Subscription[]
}

export const clientMainSection = (props: Props): FormSection => {
  const { client, customerSince, customerChurn, activeSubscription, nextSubscription, discount, billingDetails, subscriptions } = props;
  return {
    key: "clientMainDetails",
    type: "regular",
    title: "Client",
    fields: [
      {
        key: "clientName",
        label: "Name",
        render: () => <div>{client.name}</div>,
      },
      {
        key: "clientId",
        label: "Client ID",
        render: () => <div>{client.clientId}</div>,
      },
      {
        key: "access",
        label: "Access",
        render: () => <div><Tag color={client.access.hexColor} label={client.access.text} /></div>,
      },
      {
        key: "annualValue",
        label: "Annual value",
        render: () => <div>{formatCurrency(client.customerAnnualWorth, "eur")}</div>,
      },
      {
        key: "customerSince",
        label: "Customer since",
        render: () => customerSince && <div>{formatWrittenDayMonthYear(customerSince)}</div>,
        isEmpty: customerSince == null,
        inPageEdit: {
          render: ({ value, onChange, submit, cancel }: RenderEditOptions<moment.Moment>) => <OptionalDatePicker
            validatorKey="customerSince"
            focusOnMount
            value={value}
            onChange={(v, fromCalendar) => onChange(v, fromCalendar)}
            minDate={moment.utc(serverReference.constants.payment.minYearDate)}
            maxDate={moment.utc(serverReference.constants.payment.maxYearDate)}
            onEsc={() => cancel()}
            onEnter={() => submit()}
          />,
          fullWidth: false,
          type: "confirmOrCancelButtonInline",
          initialValue: customerSince ? moment.utc(customerSince) : null,
          submitChange: (newMoment) => window.CoreApi.Client.UpdateClientCustomerDate({ clientId: client.clientId, customerSince: newMoment?.toDate(), customerChurn: customerChurn?.toDate() })
        }
      },
      {
        key: "customerChurn",
        label: "Customer churn",
        render: () => customerChurn ? <div>{formatWrittenDayMonthYear(customerChurn)}</div> : null,
        isEmpty: customerChurn == null,
        inPageEdit: {
          render: ({ value, onChange, submit, cancel }: RenderEditOptions<moment.Moment>) => <OptionalDatePicker
            validatorKey="customerChurn"
            focusOnMount
            value={value}
            onChange={(v, fromCalendar) => onChange(v, fromCalendar)}
            minDate={moment.utc(serverReference.constants.payment.minYearDate)}
            maxDate={moment.utc(serverReference.constants.payment.maxYearDate)}
            onEsc={() => cancel()}
            onEnter={() => submit()}
          />,
          fullWidth: false,
          type: "confirmOrCancelButtonInline",
          initialValue: customerChurn ? moment.utc(customerChurn) : null,
          submitChange: (newMoment) => window.CoreApi.Client.UpdateClientCustomerDate({ clientId: client.clientId, customerChurn: newMoment?.toDate(), customerSince: customerSince?.toDate() }),
        }
      },
      {
        key: "subscription",
        hideLabel: true,
        label: "",
        render: () => <ClientSubscriptionSummaryContent
          activeSubscription={activeSubscription}
          nextSubscription={nextSubscription}
          discount={discount}
          client={client}
          billingDetails={billingDetails}
          subscriptions={subscriptions}
        />
      }
    ]
  }
}